import {
    Alert,
    Avatar,
    Button,
    Col,
    ConfigProvider,
    Empty,
    Form,
    FormInstance,
    message,
    Modal,
    notification,
    Progress,
    Result,
    Row,
    Space,
    Spin,
    Tooltip,
    Typography
} from 'antd';
import React, {useEffect, useState} from 'react';
import {camelCaseSplit, capitalize} from '../../../common/utils';
import './index.css';
import moment from "moment";
import {
    CustomRange,
    HalfYear,
    Month,
    NonVerbose,
    Quarter,
    ReportTypeChannel,
    ReportTypeStaticBulkChannel,
    ReportTypeStaticChannel,
    Verbose,
    Year
} from "../../../REPORTING/pages/SmartReports";
import enUSIntl from "antd/lib/locale/en_US";
import ProForm, {
    ProFormDatePicker,
    ProFormDateRangePicker,
    ProFormDependency,
    ProFormGroup,
    ProFormList,
    ProFormRadio,
    ProFormSelect,
    ProFormSwitch,
    ProFormText
} from "@ant-design/pro-form";
import {
    CheckCircleFilled,
    FileExcelOutlined,
    FilePptOutlined,
    MonitorOutlined,
    WarningOutlined
} from "@ant-design/icons";
import {useAtom} from "jotai";
import {managedReportsParamsAtom} from "../SmartReports/atoms";
import axiosApiInstance from "../../../api/axiosClient";
import dayjs from 'dayjs';
import {PageContainer} from '@ant-design/pro-components';
import {useQuery} from "@tanstack/react-query";
import {postRequest} from "../../../api/postRequest";

// New import for handling authorized channels

export interface IBrandAccountReportingProps {
    //Here we pass the Props Interface
    ppkValue?: string;
    cmsExtraId?: string
}

// export interface IBrandAccountReportingState {
//     //here we pass the State Interface
//     isGapiLibraryLoading: boolean,
//     isAuthorized: boolean,
//     isAuthorizing: boolean,
//     isRequestLoading: boolean,
//     // emptyResponse: boolean
//     brandAccountInfo?: any
//
// //test
//     processing: boolean
//     success?: any
//     error?: any
//     resultModalVisible: boolean
//     formRef: React.RefObject<FormInstance>
//     loadingChannelsFromTags?: boolean
//     processingInfoMultipleChannels?: { [k: string]: { processing: boolean, successData: any, error: any } }
//     resultBulkModalVisible: boolean
// }

type AuthChannel = {
    channel_id : string
    channel_title : string
    thumbnail_url :string
}

const BrandAccountReporting: React.FC<IBrandAccountReportingProps> = (props) => {
    const [isRequestLoading, setIsRequestLoading] = React.useState(false);
    const [isGapiLibraryLoading, setIsGapiLibraryLoading] = React.useState(false);
    const [processing, setProcessing] = React.useState(false);
    const [resultModalVisible, setResultModalVisible] = React.useState(false);
    const formRef = React.useRef<FormInstance>(null);
    const [resultBulkModalVisible, setResultBulkModalVisible] = React.useState(false);
    const [brandAccountInfo, setBrandAccountInfo] = useState(null)
    const [success, setSuccess] = useState<any | undefined>(undefined);
    const [error, setError] = useState<any | undefined>(undefined);
    const [reportsParams, setReportsParams] = useAtom(managedReportsParamsAtom)
    const [processingInfoMultipleChannels, setProcessingInfoMultipleChannels] = useState<{
        [k: string]: { processing: boolean, successData: any, error: any }
    } | undefined>(undefined);

    // Fetch authorized non-CMS channels
    const {data: authorizedChannels, isLoading: isLoadingAuthorizedChannels} = useQuery<AuthChannel[]>({
        queryKey: ['authorizedChannels'],
        queryFn: async () => {
            const response = await axiosApiInstance.get('/api/youtubereports/auth/channels');
            return response.data?.channels || [];
        },
    });

    const [form] = Form.useForm<any>();
    useEffect(() => {
        // console.log({reportsParams})
        form.setFieldsValue(reportsParams)
    }, []);
    const formValues = Form.useWatch([], form)


    useEffect(() => {
        if (!formValues) return
        // console.log('useEf')
        const periodDateRangeValue = formValues.report_type == ReportTypeStaticChannel || formValues.report_type == ReportTypeChannel
            ? formValues.channel_params?.[0]?.custom_period_daterange
            : formValues.custom_period_daterange;

        if (!Array.isArray(periodDateRangeValue) || !periodDateRangeValue[0] || !periodDateRangeValue[1]) {
            if (formValues.report_type == ReportTypeStaticChannel || formValues.report_type == ReportTypeChannel) {
                // console.log('1')
                form.setFieldValue(['channel_params', 0, 'custom_period_pop'], undefined)
                form.setFieldValue(['channel_params', 0, 'custom_period_yoy'], undefined)
            } else {
                form.setFieldValue('custom_period_pop', undefined)
                form.setFieldValue('custom_period_yoy', undefined)
            }
            return
        }
        // console.log('2')
        const numDaysInPeriod = dayjs(periodDateRangeValue[1]).diff(dayjs(periodDateRangeValue[0]), 'days') + 1
        const popStart = dayjs(periodDateRangeValue[0]).subtract(numDaysInPeriod, 'days')
        const popEnd = dayjs(periodDateRangeValue[1]).subtract(numDaysInPeriod, 'days')
        // console.log('2.1', formValues)
        if (formValues.report_type == ReportTypeStaticChannel || formValues.report_type == ReportTypeChannel) {
            // console.log('3')
            if (!formValues.channel_params[0].custom_period_pop)
                form.setFieldValue(['channel_params', 0, 'custom_period_pop'], [popStart, popEnd])
        } else {
            if (!formValues.custom_period_pop)
                form.setFieldValue('custom_period_pop', [popStart, popEnd])
        }
        const yoyStart = dayjs(periodDateRangeValue[0]).subtract(1, 'year')
        const yoyEnd = dayjs(periodDateRangeValue[1]).subtract(1, 'year')
        if (formValues.report_type == ReportTypeStaticChannel || formValues.report_type == ReportTypeChannel) {
            // console.log('4')
            if (!formValues.channel_params[0].custom_period_yoy)
                form.setFieldValue(['channel_params', 0, 'custom_period_yoy'], [yoyStart, yoyEnd])
        } else {
            if (!formValues.custom_period_yoy)
                form.setFieldValue('custom_period_yoy', [yoyStart, yoyEnd])
        }
    }, [formValues]);

    const onSubmit = async (values: any) => {
        console.log({values})
        if (values.report_type == ReportTypeStaticChannel) {
            Object.defineProperty(values, 'params',
                Object.getOwnPropertyDescriptor(values, 'channel_params')!);
            delete values['channel_params'];
            // console.log(values)

            const v = values.params[0].period
            if (values.params[0].range == Month) {
                values.params[0] = {
                    ...values.params[0],
                    start_date: moment(v, "YYYY-MM").format("YYYY-MM-DD"),
                    end_date: moment(v, "YYYY-MM").add(1, 'M').subtract(1, 'd').format("YYYY-MM-DD"),
                    period_over_period: {
                        start_date: moment(v, "YYYY-MM").subtract(1, 'M').format("YYYY-MM-DD"),
                        end_date: moment(v, "YYYY-MM").subtract(1, 'd').format("YYYY-MM-DD"),
                    },
                    year_over_year: {
                        start_date: moment(v, "YYYY-MM").subtract(1, 'y').format("YYYY-MM-DD"),
                        end_date: moment(v, "YYYY-MM").subtract(1, 'y').add(1, 'M').subtract(1, 'd').format("YYYY-MM-DD"),
                    }
                }
            }


            if (values.params[0].range == Quarter) {
                console.log(values)
                values.params[0] = {
                    ...values.params[0],
                    start_date: moment(v, "YYYY-Q").format("YYYY-MM-DD"),
                    end_date: moment(v, "YYYY-Q").add(1, 'Q').subtract(1, 'd').format("YYYY-MM-DD"),
                    period_over_period: {
                        start_date: moment(v, "YYYY-Q").subtract(1, 'Q').format("YYYY-MM-DD"),
                        end_date: moment(v, "YYYY-Q").subtract(1, 'd').format("YYYY-MM-DD"),
                    },
                    year_over_year: {
                        start_date: moment(v, "YYYY-Q").subtract(1, 'y').format("YYYY-MM-DD"),
                        end_date: moment(v, "YYYY-Q").subtract(1, 'y').add(1, 'Q').subtract(1, 'd').format("YYYY-MM-DD"),
                    }
                }
            }

            if (values.params[0].range == HalfYear) {
                const halfno = values.params[0].halfno
                values.params[0] = {
                    ...values.params[0],
                    start_date: moment(v, "YYYY").add(halfno == 1 ? 0 : 2, 'Q').format("YYYY-MM-DD"),
                    end_date: moment(v, "YYYY").add(halfno == 1 ? 2 : 4, 'Q').subtract(1, 'd').format("YYYY-MM-DD"),
                    //new
                    period_over_period: {
                        start_date: moment(v, "YYYY").add(halfno == 1 ? 0 : 2, 'Q').subtract(2, 'Q').format("YYYY-MM-DD"),
                        end_date: moment(v, "YYYY").add(halfno == 1 ? 0 : 2, 'Q').subtract(1, 'd').format("YYYY-MM-DD"),
                    },
                    year_over_year: {
                        start_date: moment(v, "YYYY").add(halfno == 1 ? 0 : 2, 'Q').subtract(1, 'y').format("YYYY-MM-DD"),
                        end_date: moment(v, "YYYY").add(halfno == 1 ? 0 : 2, 'Q').subtract(1, 'y').add(2, 'Q').subtract(1, 'd').format("YYYY-MM-DD"),
                    }
                }
            }

            if (values.params[0].range == Year) {
                values.params[0] = {
                    ...values.params[0],
                    start_date: moment(v, "YYYY").format("YYYY-MM-DD"),
                    end_date: moment(v, "YYYY").add(1, 'y').subtract(1, 'd').format("YYYY-MM-DD"),
                    //new
                    year_over_year: {
                        start_date: moment(v, "YYYY").subtract(1, 'y').format("YYYY-MM-DD"),
                        end_date: moment(v, "YYYY").subtract(1, 'd').format("YYYY-MM-DD"),
                    }
                }
            }

            if (values.params[0].range == CustomRange) {
                values.params[0] = {
                    ...values.params[0],
                    start_date: moment(values.params[0].custom_period_daterange[0]).format("YYYY-MM-DD"),
                    end_date: moment(values.params[0].custom_period_daterange[1]).format("YYYY-MM-DD"),
                    period_over_period: {
                        start_date: moment(values.params[0].custom_period_pop[0]).format("YYYY-MM-DD"),
                        end_date: moment(values.params[0].custom_period_pop[1]).format("YYYY-MM-DD"),
                    },
                    year_over_year: {
                        start_date: moment(values.params[0].custom_period_yoy[0]).format("YYYY-MM-DD"),
                        end_date: moment(values.params[0].custom_period_yoy[1]).format("YYYY-MM-DD"),
                    },
                    custom_period_pop_enabled: values.params[0].custom_period_pop_enabled,
                    custom_period_yoy_enabled: values.params[0].custom_period_yoy_enabled,
                }
            }

            // delete values.params[0]['range']
            delete values.params[0]['period']

            if (!values.report_template_requests) {
                values.report_template_requests = []
            }

            values.params[0]['is_brand_account'] = true
            // values.params[0]['auth_token'] = this.state.brandAccountInfo["Cc"]["access_token"]
            // values.params[0]['auth_token'] = this.state.brandAccountInfo["Cc"]["login_hint"]
            console.log({values})

            // console.log(values)

        }

        if (values.report_type == ReportTypeStaticBulkChannel) {
            if (values.channel_params.length == 0) {
                notification.warning({message: 'No channels provided.'})
                return
            }
            setProcessing(true);
            setSuccess(null);
            setError(null);
            setProcessingInfoMultipleChannels({});
            // console.log({values})
            setResultBulkModalVisible(true);
            // console.log('HHH')
            for (let i = 0; i < values.channel_params[0].channel_id.length; i++) {
                // console.log({i})

                let requestData: any = {
                    params: [
                        {
                            channel_id: values.channel_params[0].channel_id[i],
                            start_date: values.channel_params[0].start_date,
                            end_date: values.channel_params[0].end_date,
                            verbose: values.channel_params[0].verbose,
                            range: values.channel_params[0].range,
                            period: values.channel_params[0].period,
                            is_brand_account: true
                        }
                    ],
                    report_template_requests: values.channel_params[0].report_template_requests || [],
                    report_type: values.report_type
                }
                console.log('HHH', {requestData})
                const period = requestData.params[0].period
                const range = requestData.params[0].range
                if (range == Month) {
                    requestData.params[0] = {
                        ...requestData.params[0],
                        start_date: moment(period, "YYYY-MM").format("YYYY-MM-DD"),
                        end_date: moment(period, "YYYY-MM").add(1, 'M').subtract(1, 'd').format("YYYY-MM-DD"),
                        period_over_period: {
                            start_date: moment(period, "YYYY-MM").subtract(1, 'M').format("YYYY-MM-DD"),
                            end_date: moment(period, "YYYY-MM").subtract(1, 'd').format("YYYY-MM-DD"),
                        },
                        year_over_year: {
                            start_date: moment(period, "YYYY-MM").subtract(1, 'y').format("YYYY-MM-DD"),
                            end_date: moment(period, "YYYY-MM").subtract(1, 'y').add(1, 'M').subtract(1, 'd').format("YYYY-MM-DD"),
                        }
                    }
                }


                if (range == Quarter) {
                    // console.log(requestData)
                    requestData.params[0] = {
                        ...requestData.params[0],
                        start_date: moment(period, "YYYY-Q").format("YYYY-MM-DD"),
                        end_date: moment(period, "YYYY-Q").add(1, 'Q').subtract(1, 'd').format("YYYY-MM-DD"),
                        period_over_period: {
                            start_date: moment(period, "YYYY-Q").subtract(1, 'Q').format("YYYY-MM-DD"),
                            end_date: moment(period, "YYYY-Q").subtract(1, 'd').format("YYYY-MM-DD"),
                        },
                        year_over_year: {
                            start_date: moment(period, "YYYY-Q").subtract(1, 'y').format("YYYY-MM-DD"),
                            end_date: moment(period, "YYYY-Q").subtract(1, 'y').add(1, 'Q').subtract(1, 'd').format("YYYY-MM-DD"),
                        }
                    }
                }

                if (range == HalfYear) {
                    const halfno = values.halfno
                    requestData.params[0] = {
                        ...requestData.params[0],
                        start_date: moment(period, "YYYY").add(halfno == 1 ? 0 : 2, 'Q').format("YYYY-MM-DD"),
                        end_date: moment(period, "YYYY").add(halfno == 1 ? 2 : 4, 'Q').subtract(1, 'd').format("YYYY-MM-DD"),
                        //new
                        period_over_period: {
                            start_date: moment(period, "YYYY").add(halfno == 1 ? 0 : 2, 'Q').subtract(2, 'Q').format("YYYY-MM-DD"),
                            end_date: moment(period, "YYYY").add(halfno == 1 ? 0 : 2, 'Q').subtract(1, 'd').format("YYYY-MM-DD"),
                        },
                        year_over_year: {
                            start_date: moment(period, "YYYY").add(halfno == 1 ? 0 : 2, 'Q').subtract(1, 'y').format("YYYY-MM-DD"),
                            end_date: moment(period, "YYYY").add(halfno == 1 ? 0 : 2, 'Q').subtract(1, 'y').add(2, 'Q').subtract(1, 'd').format("YYYY-MM-DD"),
                        }
                    }
                }

                if (range == Year) {
                    requestData.params[0] = {
                        ...requestData.params[0],
                        start_date: moment(period, "YYYY").format("YYYY-MM-DD"),
                        end_date: moment(period, "YYYY").add(1, 'y').subtract(1, 'd').format("YYYY-MM-DD"),
                        //test
                        // period_over_period: {
                        //     start_date: moment(period, "YYYY").subtract(1, 'y').format("YYYY-MM-DD"),
                        //     end_date: moment(period, "YYYY").subtract(1, 'd').format("YYYY-MM-DD"),
                        // },
                        //new
                        year_over_year: {
                            start_date: moment(period, "YYYY").subtract(1, 'y').format("YYYY-MM-DD"),
                            end_date: moment(period, "YYYY").subtract(1, 'd').format("YYYY-MM-DD"),
                        }
                    }
                }

                if (range == CustomRange) {
                    requestData.params[0] = {
                        ...requestData.params[0],
                        start_date: moment(values.custom_period_daterange[0]).format("YYYY-MM-DD"),
                        end_date: moment(values.custom_period_daterange[1]).format("YYYY-MM-DD"),
                        period_over_period: {
                            start_date: moment(values.custom_period_pop[0]).format("YYYY-MM-DD"),
                            end_date: moment(values.custom_period_pop[1]).format("YYYY-MM-DD"),
                        },
                        year_over_year: {
                            start_date: moment(values.custom_period_yoy[0]).format("YYYY-MM-DD"),
                            end_date: moment(values.custom_period_yoy[1]).format("YYYY-MM-DD"),
                        },
                        custom_period_pop_enabled: values.custom_period_pop_enabled,
                        custom_period_yoy_enabled: values.custom_period_yoy_enabled,
                    }
                }

                console.log({requestData})
                // return

                // console.log({requestData}); return;
                setProcessingInfoMultipleChannels(prevState => ({
                    ...prevState,
                    [requestData.params[0].channel_id]: {
                        processing: true,
                        error: undefined,
                        successData: undefined
                    }
                }));
                try {
                    const res = await postRequest(`/api/youtubereports/make/${requestData.report_type}`, requestData, false)
                    console.log({res: res.data})
                    //    show result Modal
                    //update object
                    setProcessingInfoMultipleChannels(prevState => {
                        let processingInfoMultipleChannels = {...prevState};
                        let processingInfo = {...processingInfoMultipleChannels[1]};
                        processingInfo.processing = false;
                        processingInfo.successData = res.data;
                        processingInfo.error = null;
                        processingInfoMultipleChannels[requestData.params[0].channel_id] = processingInfo;
                        return processingInfoMultipleChannels;
                    });
                } catch (err) {
                    let message = capitalize(err.response.data.message)
                    console.log({err: message})

                    //update object
                    setProcessingInfoMultipleChannels(prevState => {
                        let processingInfoMultipleChannels = {...prevState};
                        let processingInfo = {...processingInfoMultipleChannels[requestData.params[0].channel_id]};
                        processingInfo.processing = false;
                        processingInfo.successData = null;
                        processingInfo.error = message;
                        processingInfoMultipleChannels[requestData.params[0].channel_id[i]] = processingInfo;
                        return processingInfoMultipleChannels;
                    });

                    setProcessing(false);
                    notification.error({message, duration: 0});
                }

            }
            setProcessing(false)
            return

        }


        console.log({values})
        // console.log(values.params[0])
        // console.log(values.report_template_requests[0])
        // console.log(values.report_template_requests[1])

        // return

        setProcessing(true);
        setSuccess(null);
        setError(null);

        axiosApiInstance.post(`/api/youtubereports/make/${values.report_type}`, values).then((res) => {
            setProcessing(false);
            setSuccess(res.data);
            console.log({res});
            // Show result Modal
            setResultModalVisible(true);
        }).catch((err) => {
            let message = capitalize(err.response.data.message);
            setProcessing(false);
            setError(message);
            notification.error({message, duration: 0});
        });
    }

    return (
        <div className="BrandAccountReporting">
            <PageContainer>
                <Row style={{width: '100%'}}>
                    {/*{!this.state.isAuthorized && !this.state.isAuthorizing && !this.state.isGapiLibraryLoading &&*/}
                    {/*<Row justify='center'><Text type='danger'>You are not authorized to access the performance data*/}
                    {/*    of this asset.</Text></Row>}*/}
                    {isGapiLibraryLoading && !isRequestLoading && <Row justify='center'>
                        <Spin spinning={true}
                            // tip='Library loading...'
                        />
                    </Row>}

                    <div style={{width: '100%'}}>
                        <Spin spinning={isRequestLoading} tip='Loading...' style={{width: '100%'}}>
                            {/*{!this.state.isGapiLibraryLoading && this.state.isAuthorized && !this.state.isRequestLoading &&*/}

                            <>
                                <Spin spinning={processing} tip={"Processing... This won't take long."}>

                                    <Alert
                                        message={<>
                                            <Typography.Text type={"secondary"}>
                                                {"For detailed documentation, see "}
                                                <Typography.Link
                                                    href="https://developers.google.com/youtube/analytics/content_owner_reports#video-reports"
                                                    target={"_blank"}>the official docs</Typography.Link>.
                                            </Typography.Text>
                                        </>}
                                        type={"info"}
                                        showIcon={true}
                                    />

                                    <ConfigProvider locale={enUSIntl}>
                                        <ProForm size={"large"} onFinish={(values) => onSubmit(values)}
                                                 form={form} style={{width: '100%'}}
                                                 onValuesChange={(changedValues, values) => {
                                                     console.log({values})
                                                     setReportsParams(values)
                                                 }}
                                            // submitter={{submitButtonProps:{title:'test'}}}
                                                 submitter={{
                                                     searchConfig: {submitText: 'Submit'},
                                                     render: (_, dom) => [...dom,
                                                         // <Button size={'large'} onClick={handleAuthorize}>
                                                         //     Authorize Channel
                                                         // </Button>,
                                                         <Button size={'large'}
                                                                 href={'/reporting/youtube-authorizations'} /*target={'_blank'}*/
                                                                 type={'link'}>
                                                             Manage Authorizations
                                                         </Button>,

                                                     ]
                                                 }}
                                        >
                                            {/*Report Type*/}
                                            <ProFormSelect name="report_type" label={"Report Type"}
                                                // disabled
                                                           initialValue={ReportTypeStaticChannel}
                                                           rules={[{required: true}]}
                                                           fieldProps={{defaultActiveFirstOption: true}} // works ? maybe not
                                                // request={async () => {
                                                //     let res = await axiosApiInstance.post('/api/youtubereports/supported_report_types')
                                                //     let data = res.data
                                                //     // let options: { [k: string]: string }[] = [] Doesnt work
                                                //     // data.map((i: string) => options.push({i}))
                                                //     let options: { label?: string, value?: string }[] = []
                                                //     data.map((i: string) => options.push({
                                                //         label: camelCaseSplit(i),
                                                //         value: i
                                                //     }))
                                                //     // console.log({options})
                                                //     return options
                                                // }}
                                                           options={[
                                                               {
                                                                   label: camelCaseSplit(ReportTypeStaticChannel),
                                                                   value: ReportTypeStaticChannel
                                                               },
                                                               {
                                                                   label: camelCaseSplit(ReportTypeStaticBulkChannel),
                                                                   value: ReportTypeStaticBulkChannel
                                                               }
                                                           ]}

                                            />
                                            {/*Params*/}
                                            <ProFormDependency name={['report_type']}>
                                                {({report_type}) => {
                                                    // console.log({report_type})
                                                    if (!report_type) {
                                                        return <Empty description={"Select a report type"}/>;
                                                    }


                                                    return <>
                                                        <ProFormList
                                                            name={['channel_params']}
                                                            label="Report Parameters"
                                                            creatorButtonProps={false}
                                                            deleteIconProps={false}
                                                            copyIconProps={false}
                                                            initialValue={[
                                                                {}
                                                            ]}
                                                            key={'channel-list'}
                                                        >

                                                            <ProFormGroup>
                                                                {report_type == ReportTypeStaticChannel ?
                                                                    (<ProFormSelect
                                                                        name="channel_id"
                                                                        label="Channel"
                                                                        placeholder="Select an authorized channel"
                                                                        rules={[{required: true}]}
                                                                        fieldProps={{
                                                                            loading: isLoadingAuthorizedChannels
                                                                        }}
                                                                        options={authorizedChannels?.map(channel => ({
                                                                            label: (
                                                                                <Tooltip
                                                                                    title={channel.channel_id}>
                                                                                    <Avatar
                                                                                        src={channel.thumbnail_url}
                                                                                        size="small"
                                                                                        style={{marginRight: 8}}
                                                                                    />
                                                                                    {channel.channel_title || "Untitled"}
                                                                                </Tooltip>
                                                                            ),
                                                                            value: channel.channel_id
                                                                        })) || []}
                                                                    />) :
                                                                    (<ProFormSelect
                                                                        name="channel_id"
                                                                        label="Channel"
                                                                        placeholder="Select authorized channels"
                                                                        rules={[{required: true}]}
                                                                        fieldProps={{
                                                                            loading: isLoadingAuthorizedChannels
                                                                        }}
                                                                        mode={'multiple'}
                                                                        options={authorizedChannels?.map(channel => ({
                                                                            label: (
                                                                                <Tooltip
                                                                                    title={channel.channel_id}>
                                                                                    <Avatar
                                                                                        src={channel.thumbnail_url}
                                                                                        size="small"
                                                                                        style={{marginRight: 8}}
                                                                                    />
                                                                                    {channel.channel_title || "Untitled"}
                                                                                </Tooltip>
                                                                            ),
                                                                            value: channel.channel_id
                                                                        })) || []}
                                                                    />)
                                                                }

                                                                <ProFormRadio.Group
                                                                    name={"range"}
                                                                    label="Range"
                                                                    radioType="button"
                                                                    options={[
                                                                        {label: 'Month', value: Month,},
                                                                        {label: 'Quarter', value: Quarter,},
                                                                        {
                                                                            label: 'Half-Year',
                                                                            value: HalfYear,
                                                                        },
                                                                        {label: 'Year', value: Year,},
                                                                        {label: 'Custom', value: CustomRange,},
                                                                    ]}
                                                                    initialValue={Month}
                                                                    rules={[{required: true}]}
                                                                />


                                                                <ProFormDependency name={['range']}>
                                                                    {({range}) => {
                                                                        // let range=range.range
                                                                        // console.log({range})
                                                                        if (!range) {
                                                                            return <Empty
                                                                                description={"Select range"}/>;
                                                                        }
                                                                        if (range == Month) {
                                                                            return (
                                                                                <>
                                                                                    <ProFormDatePicker.Month
                                                                                        name="period"
                                                                                        label="Period"
                                                                                        fieldProps={{
                                                                                            format: 'YYYY-MM',
                                                                                            // onChange:(v,d)=>{
                                                                                            //     console.log(v,d)
                                                                                            // }
                                                                                        }}

                                                                                        rules={[{
                                                                                            // type: 'object',
                                                                                            required: true,
                                                                                        }]}
                                                                                        initialValue={moment(moment().startOf('month').subtract(1, 'month'), "YYYY-MM-DD")}
                                                                                    />

                                                                                </>
                                                                            )
                                                                        }
                                                                        if (range == Quarter) {
                                                                            return <ProFormDatePicker.Quarter
                                                                                name="period"
                                                                                label="Period"
                                                                                fieldProps={{
                                                                                    format: "YYYY-Q"
                                                                                }}

                                                                                rules={[{
                                                                                    required: true,
                                                                                }]}
                                                                            />
                                                                        }
                                                                        if (range == HalfYear) {
                                                                            return <ProFormDatePicker.Year
                                                                                name="period"
                                                                                label="Period"
                                                                                addonAfter={
                                                                                    <ProFormRadio.Group
                                                                                        name="halfno"
                                                                                        noStyle
                                                                                        radioType="button"
                                                                                        options={[
                                                                                            {
                                                                                                label: '1st',
                                                                                                value: 1,
                                                                                            },
                                                                                            {
                                                                                                label: '2nd',
                                                                                                value: 2,
                                                                                            },
                                                                                        ]}
                                                                                        initialValue={1}
                                                                                        rules={[{required: true}]}
                                                                                        // transform={(_) => ({})}
                                                                                    />
                                                                                }
                                                                                fieldProps={{
                                                                                    format: 'YYYY'
                                                                                }}

                                                                                rules={[{
                                                                                    required: true,
                                                                                }]}
                                                                            />
                                                                        }
                                                                        if (range == Year) {
                                                                            return <ProFormDatePicker.Year
                                                                                name="period"
                                                                                label="Period"
                                                                                fieldProps={{
                                                                                    format: 'YYYY'
                                                                                }}

                                                                                rules={[{
                                                                                    required: true,
                                                                                }]}
                                                                            />
                                                                        }
                                                                        if (range == CustomRange) {
                                                                            return <ProFormDateRangePicker
                                                                                name="custom_period_daterange"
                                                                                label="Period"
                                                                                rules={[{
                                                                                    required: true,
                                                                                }]}
                                                                            />

                                                                        }
                                                                        return null
                                                                    }
                                                                    }
                                                                </ProFormDependency>

                                                                <ProFormDependency
                                                                    name={['range', 'custom_period_daterange']}>
                                                                    {({range, custom_period_daterange}) => {
                                                                        if (range == CustomRange) {
                                                                            if (!Array.isArray(custom_period_daterange) || !custom_period_daterange[0] || !custom_period_daterange[1]) {
                                                                                return <ProFormGroup>
                                                                                    <ProFormDateRangePicker
                                                                                        label="Compare Period 1 (PoP by default)"
                                                                                        disabled
                                                                                        addonAfter={
                                                                                            <ProFormSwitch
                                                                                                disabled/>}

                                                                                    />
                                                                                    <ProFormDateRangePicker
                                                                                        label="Compare Period 2 (YoY by default)"
                                                                                        disabled
                                                                                        addonAfter={
                                                                                            <ProFormSwitch
                                                                                                disabled/>}
                                                                                    />
                                                                                </ProFormGroup>
                                                                            }

                                                                            return <ProFormGroup>
                                                                                <ProFormDateRangePicker
                                                                                    name="custom_period_pop"
                                                                                    label="Compare Period 1 (PoP by default)"
                                                                                    fieldProps={{
                                                                                        // format: 'YYYY-MM',
                                                                                        // picker: 'month'
                                                                                        // defaultValue: [popStart, popEnd]
                                                                                    }}
                                                                                    // initialValue={[popStart, popEnd]}
                                                                                    disabled={formValues?.channels_params ? !formValues?.channels_params[0]?.custom_period_pop_enabled : undefined}
                                                                                    rules={[{
                                                                                        required: true,
                                                                                    }]}
                                                                                    addonAfter={
                                                                                        <ProFormSwitch
                                                                                            name="custom_period_pop_enabled"
                                                                                            checkedChildren={"Include"}
                                                                                            unCheckedChildren={"Exclude"}
                                                                                            initialValue={true}/>
                                                                                    }

                                                                                />
                                                                                <ProFormDateRangePicker
                                                                                    name="custom_period_yoy"
                                                                                    label="Compare Period 2 (YoY by default)"
                                                                                    fieldProps={{
                                                                                        // format: 'YYYY-MM',
                                                                                        // picker: 'month'
                                                                                        // defaultValue: [yoyStart, yoyEnd]
                                                                                    }}
                                                                                    // initialValue={[yoyStart, yoyEnd]}
                                                                                    rules={[{
                                                                                        required: true,
                                                                                    }]}
                                                                                    disabled={formValues?.channels_params ? !formValues?.channels_params[0]?.custom_period_yoy_enabled : undefined}
                                                                                    addonAfter={
                                                                                        <ProFormSwitch
                                                                                            name="custom_period_yoy_enabled"
                                                                                            checkedChildren={"Include"}
                                                                                            unCheckedChildren={"Exclude"}
                                                                                            initialValue={true}/>

                                                                                    }
                                                                                />

                                                                            </ProFormGroup>
                                                                        }
                                                                        return null
                                                                    }
                                                                    }
                                                                </ProFormDependency>

                                                                <ProFormDependency name={['range']}>
                                                                    {({range}) => {
                                                                        // if (range == HalfYear || range == Year) return null
                                                                        return (<ProFormRadio.Group
                                                                            name={"verbose"}
                                                                            label="Verbose"
                                                                            radioType="button"
                                                                            options={[
                                                                                {
                                                                                    label: 'Yes',
                                                                                    value: Verbose,
                                                                                },
                                                                                {
                                                                                    label: 'No',
                                                                                    value: NonVerbose,
                                                                                }
                                                                            ]}
                                                                            initialValue={Verbose}
                                                                            rules={[{required: true}]}
                                                                            // disabled={range == HalfYear || range == Year}
                                                                            // help={range == HalfYear || range == Year ? 'Only non-comparative reports can be exported.' : 'Applies to every template request where Verbose=Auto.'}
                                                                            help={range == Year ? 'Only non-verbose reports can be exported.' : 'Applies to every template request where Verbose=Auto.'}
                                                                        />)
                                                                    }}
                                                                </ProFormDependency>

                                                            </ProFormGroup>

                                                        </ProFormList>
                                                    </>


                                                    return null;
                                                }}


                                            </ProFormDependency>

                                            {/*<Row>*/}
                                            {/*    <Col span={24}>*/}
                                            <ProFormDependency name={['report_type']} ignoreFormListField
                                                               style={{width: '100%'}}>
                                                {({report_type}) => {
                                                    // console.log({report_type})
                                                    if (!report_type) {
                                                        return null;
                                                        // return <Empty description={"Select a report type"}/>;
                                                    }

                                                    if (report_type.includes("Static")) {
                                                        return <>
                                                            <Alert
                                                                message={"The templates included in the static report are the following:"}
                                                                showIcon
                                                            />
                                                            <Alert
                                                                message={"" +
                                                                    // "The templates included in the static report are the following:\n" +
                                                                    "- Key Channel Metrics\n" +
                                                                    // "\t* Key Channel Metrics\n" +
                                                                    "- Performance Overview\n" +
                                                                    "\t* Views\n" +
                                                                    "\t* Watchtime\n" +
                                                                    "\t* Top Videos\n" +
                                                                    "\t* Subscribers vs Non Subscribers Watchtime\n" +
                                                                    "\t* Subscribers Growth\n" +
                                                                    "\t* Subscribers Source\n" +
                                                                    "\t* Subscribers YouTube Watch Page\n" +
                                                                    "- Channel Reach\n" +
                                                                    "\t* Traffic Sources (Views)\n" +
                                                                    "\t* Traffic Sources: YouTube Search (Keywords)\n" +
                                                                    "\t* Devices\n" +
                                                                    "\t* Playback Locations\n" +
                                                                    "- Audience Demographics\n" +
                                                                    "\t* Age Groups\n" +
                                                                    "\t* Gender\n" +
                                                                    "\t* Geography\n" +
                                                                    "- Engagement\n" +
                                                                    "\t* Likes\n" +
                                                                    "\t* Shares\n" +
                                                                    "\t* Endscreens/Cards\n" +
                                                                    "\t* Playlists\n"
                                                                    // "Please not that these templates cannot be modified by the user in the 'static' report type."
                                                                }
                                                                type={"info"}
                                                                // showIcon
                                                                style={{whiteSpace: "pre"}}
                                                            />
                                                            <Alert
                                                                message={"Please not that these templates cannot be modified by the user in the 'static' report type."}
                                                                showIcon
                                                            />
                                                            <br/>
                                                        </>
                                                    }


                                                }}
                                            </ProFormDependency>
                                            {/*</Col>*/}
                                            {/*</Row>*/}
                                        </ProForm>
                                    </ConfigProvider>
                                </Spin>


                                {/*Result Modal For single channel*/}
                                {success &&
                                    <Modal
                                        visible={resultModalVisible}
                                        onOk={() => {
                                            setResultModalVisible(false)
                                        }}
                                        closable={false}
                                        maskClosable={true}
                                        cancelButtonProps={{hidden: true}}
                                    >
                                        <Result title={"Report Created Successfully!"} status="success" subTitle={
                                            <>
                                                <Typography.Text type={"secondary"}>Shared with:
                                                    digitalminds.com</Typography.Text>
                                            </>
                                        }
                                                extra={[
                                                    <a href={success.presentationUrl} target={"_blank"}>
                                                        <Button size={"large"} type="primary" key="presentation"
                                                                icon={<FilePptOutlined/>}>Go To
                                                            Presentation</Button>
                                                    </a>,
                                                    <a href={success.spreadsheetUrl} target={"_blank"}>
                                                        <Button size={"large"} key="spreadsheet"
                                                                icon={<FileExcelOutlined/>}>Go To
                                                            Spreadsheet</Button>
                                                    </a>
                                                ]}
                                        />

                                    </Modal>
                                }


                                {/*Processing/Result Modal For multi channel*/}
                                {resultBulkModalVisible && form.getFieldValue('report_type').includes("Bulk") && form.getFieldValue('channel_params') !== undefined &&
                                    // {true &&
                                    <Modal
                                        visible={resultBulkModalVisible}
                                        // visible={true}
                                        onOk={() => {
                                            setResultBulkModalVisible(false)
                                        }}
                                        width={1100}
                                        bodyStyle={{height: 500, overflowY: 'auto'}}
                                        // maskStyle={{width:2000}}
                                        // closable={true}
                                        okButtonProps={{disabled: processing}}
                                        closable={false}
                                        maskClosable={false}
                                        cancelButtonProps={{hidden: true}}
                                    >
                                        <Result title={processing ? "Processing Reports..." : "Done!"}
                                                icon={processing ? <MonitorOutlined/> :
                                                    <CheckCircleFilled style={{color: '#52c41a'}}/>} subTitle={
                                            <>
                                                <br/>
                                                <ConfigProvider locale={enUSIntl}>
                                                    <ProForm size={"large"} submitter={false}>
                                                        <Row justify={'center'} align={'middle'}>
                                                            <ProFormList
                                                                name={['result_multi_channel']}
                                                                // label="Report Parameters"
                                                                creatorButtonProps={false}
                                                                deleteIconProps={false}
                                                                copyIconProps={false}
                                                                initialValue={form.getFieldValue('channel_params')[0]?.channel_id}
                                                                // initialValue={[
                                                                //     {channel_id: 'UCnJnnEztMhpBEZaVORLriFg'},
                                                                //     {channel_id: 'UCcbNHNmULeU1OoNylpPIRQQ'},
                                                                // ]}
                                                                key={'result-bulk-channel-list'}
                                                            >
                                                                {(field, index, op) => {
                                                                    return (
                                                                        <>
                                                                            <Col style={{
                                                                                width: 900,
                                                                                alignItems: 'center'
                                                                            }}>
                                                                                {/*<Col span={12}>*/}

                                                                                <ProFormText
                                                                                    name={"channel_id"}
                                                                                    readonly
                                                                                    addonBefore={index + 1}
                                                                                    addonAfter={
                                                                                        <Space>
                                                                                            <Form.Item noStyle
                                                                                                       shouldUpdate>
                                                                                                {(_) => {
                                                                                                    const channel_id = form.getFieldValue('channel_params')[0]?.channel_id[index]
                                                                                                    console.log({channel_id})
                                                                                                    // if (this.state.form.getFieldValue('bulk_channel_params')[index]) {
                                                                                                    //     console.log(this.state.form.getFieldValue('bulk_channel_params')[index])
                                                                                                    // }
                                                                                                    if (!channel_id) return null
                                                                                                            const channel_info = authorizedChannels.find(i=> i.channel_id == channel_id)
                                                                                                    return <Row
                                                                                                        // style={{width: 500}}
                                                                                                        align={'middle'}
                                                                                                        justify={'space-around'}>

                                                                                                        {/*<Col span={12} >*/}
                                                                                                        <Col
                                                                                                            style={{width: 300}}>
                                                                                                            {/*<ChannelInfoData*/}
                                                                                                            {/*    channel_id={channel_id}/>*/}
                                                                                                            <Space>
                                                                                                                <Avatar
                                                                                                                    src={channel_info?.thumbnail_url}
                                                                                                                    size="small"
                                                                                                                    style={{marginRight: 8}}
                                                                                                                />
                                                                                                                {channel_info?.channel_title || "Untitled"}
                                                                                                            </Space>
                                                                                                        </Col>

                                                                                                        {/*<Col span={8}>*/}
                                                                                                        <Col
                                                                                                            style={{width: 200}}>
                                                                                                            {/*<Progress*/}
                                                                                                            {/*    size="small"*/}
                                                                                                            {/*    status={'active'}*/}
                                                                                                            {/*    percent={100}*/}
                                                                                                            {/*    showInfo={false}/>*/}
                                                                                                            {processingInfoMultipleChannels !== undefined && processingInfoMultipleChannels![channel_id]?.processing &&
                                                                                                                <Progress
                                                                                                                    status={'active'}
                                                                                                                    percent={100}
                                                                                                                    showInfo={false}/>}
                                                                                                            {processingInfoMultipleChannels !== undefined && processingInfoMultipleChannels![channel_id]?.successData &&
                                                                                                                <Progress
                                                                                                                    status={'success'}
                                                                                                                    percent={100}
                                                                                                                    showInfo={false}/>}
                                                                                                            {processingInfoMultipleChannels !== undefined && processingInfoMultipleChannels![channel_id]?.error &&
                                                                                                                <Progress
                                                                                                                    status={'exception'}
                                                                                                                    percent={100}
                                                                                                                    showInfo={false}/>}
                                                                                                        </Col>

                                                                                                        {/*<Col span={4}>*/}
                                                                                                        <Col
                                                                                                            style={{width: 150}}>

                                                                                                            {/*<Space>*/}
                                                                                                            {/*    <a href={''}*/}
                                                                                                            {/*       target={"_blank"}>*/}
                                                                                                            {/*        <FilePptOutlined*/}
                                                                                                            {/*            style={{fontSize: 24}}/>*/}
                                                                                                            {/*    </a>*/}
                                                                                                            {/*    <a href={''}*/}
                                                                                                            {/*       target={"_blank"}>*/}
                                                                                                            {/*        <FileExcelOutlined*/}
                                                                                                            {/*            style={{fontSize: 24}}/>*/}
                                                                                                            {/*    </a>*/}
                                                                                                            {/*</Space>*/}

                                                                                                            {processingInfoMultipleChannels !== undefined && processingInfoMultipleChannels![channel_id]?.successData &&
                                                                                                                <Space>
                                                                                                                    <Tooltip
                                                                                                                        title={"Go To Presentation"}>
                                                                                                                        <a href={processingInfoMultipleChannels![channel_id]?.successData.presentationUrl}
                                                                                                                           target={"_blank"}>
                                                                                                                            <FilePptOutlined
                                                                                                                                style={{fontSize: 24}}/>
                                                                                                                        </a>
                                                                                                                    </Tooltip>
                                                                                                                    <Tooltip
                                                                                                                        title={"Go To Spreadsheet"}>
                                                                                                                        <a href={processingInfoMultipleChannels![channel_id]?.successData.spreadsheetUrl}
                                                                                                                           target={"_blank"}>
                                                                                                                            <FileExcelOutlined
                                                                                                                                style={{fontSize: 24}}/>
                                                                                                                        </a>
                                                                                                                    </Tooltip>
                                                                                                                </Space>
                                                                                                            }
                                                                                                            {processingInfoMultipleChannels !== undefined && processingInfoMultipleChannels![channel_id]?.error &&
                                                                                                                <Tooltip
                                                                                                                    title={processingInfoMultipleChannels![channel_id]?.error}>
                                                                                                                    <WarningOutlined/>
                                                                                                                </Tooltip>
                                                                                                            }
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                }}
                                                                                            </Form.Item>

                                                                                        </Space>
                                                                                    }
                                                                                />

                                                                            </Col>

                                                                        </>
                                                                    )
                                                                }
                                                                }
                                                            </ProFormList>
                                                        </Row>
                                                    </ProForm>
                                                </ConfigProvider>
                                            </>
                                        }
                                        />

                                    </Modal>
                                }
                            </>
                            {/*}*/}

                        </Spin>
                    </div>
                </Row>

            </PageContainer>
        </div>
    );

}

export default BrandAccountReporting;